"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _newComponents = require("../../new-components");
var _TermsCheckbox = _interopRequireDefault(require("../../TermsCheckbox"));
var _PaymentResponseMessage = _interopRequireDefault(require("../../PaymentResponseMessage"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ConfirmModal = function ConfirmModal(_ref) {
  var checkoutToken = _ref.checkoutToken,
    setCheckoutToken = _ref.setCheckoutToken,
    product = _ref.product,
    girls = _ref.girls,
    guys = _ref.guys,
    baseUrl = _ref.baseUrl,
    minAge = _ref.minAge,
    onSuccess = _ref.onSuccess,
    id = _ref.id,
    scheme = _ref.scheme,
    weekTerms = _ref.weekTerms,
    destinationId = _ref.destinationId,
    scheduledPayments = _ref.scheduledPayments,
    travelInsuranceCheckBox = _ref.travelInsuranceCheckBox,
    travelTermsCheckboxId = _ref.travelTermsCheckboxId;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isPaying = _useState2[0],
    setIsPaying = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    newPayment = _useState4[0],
    setNewPayment = _useState4[1];
  return /*#__PURE__*/_react["default"].createElement(_newComponents.Modal, {
    on: !!checkoutToken,
    toggle: function toggle() {
      return setCheckoutToken(null);
    }
  }, /*#__PURE__*/_react["default"].createElement(_newComponents.Toggle, null, function (_ref2) {
    var termsAgreed = _ref2.on,
      toggleTermsAgreed = _ref2.toggle;
    return /*#__PURE__*/_react["default"].createElement(_newComponents.Toggle, null, function (_ref3) {
      var travelTermsAgreed = _ref3.on,
        toggleTravelTermsAgreed = _ref3.toggle;
      var payButtonEnabled = !isPaying && termsAgreed && (travelInsuranceCheckBox ? travelTermsAgreed : true);
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_TermsCheckbox["default"], {
        id: id,
        travelTermsCheckboxId: travelTermsCheckboxId,
        product: product,
        termsAgreed: termsAgreed,
        toggleTermsAgreed: toggleTermsAgreed,
        girls: girls,
        guys: guys,
        baseUrl: baseUrl,
        minAge: minAge,
        weekTerms: weekTerms,
        destinationId: destinationId,
        scheduledPayments: scheduledPayments,
        travelTermsAgreed: travelTermsAgreed,
        toggleTravelTermsAgreed: toggleTravelTermsAgreed,
        travelInsuranceCheckBox: travelInsuranceCheckBox
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
        buttonType: _newComponents.BUTTON_TYPES.SUCCESS,
        text: isPaying ? 'Paying...' : 'Confirm and pay',
        disabled: !payButtonEnabled,
        onClick: function onClick() {
          setIsPaying(true);
          onSuccess(checkoutToken, '', scheme).then(function (payment) {
            setIsPaying(false);
            setNewPayment(payment);
          })["catch"](function (ex) {
            return console.error('Failed processing token', ex);
          });
        }
      })), newPayment && /*#__PURE__*/_react["default"].createElement(_PaymentResponseMessage["default"], {
        payment: newPayment
      }));
    });
  }));
};
ConfirmModal.propTypes = {
  product: _propTypes["default"].string.isRequired,
  onSuccess: _propTypes["default"].func.isRequired,
  girls: _propTypes["default"].string.isRequired,
  guys: _propTypes["default"].string.isRequired,
  baseUrl: _propTypes["default"].string.isRequired,
  minAge: _propTypes["default"].number.isRequired,
  checkoutToken: _propTypes["default"].string.isRequired,
  setCheckoutToken: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string.isRequired,
  travelTermsCheckboxId: _propTypes["default"].string,
  scheme: _propTypes["default"].string,
  weekTerms: _propTypes["default"].string,
  destinationId: _propTypes["default"].number,
  scheduledPayments: _propTypes["default"].array,
  travelInsuranceCheckBox: _propTypes["default"].bool
};
var _default = exports["default"] = ConfirmModal;